'use client'

import { FunctionComponent, useContext, useEffect, useRef } from 'react'
import { CartContext } from '../../context/CartContext'
import { UserContext } from '../../context/UserContext'
import { gtmPushCartEvent, waitForPageView } from '../../utils/gtmHelpers'

const CartGtmEvent: FunctionComponent<{ event: string }> = ({ event }) => {
  const { cart, fixItemsTitle } = useContext(CartContext)
  const { hydrated } = useContext(UserContext)
  const triggered = useRef(false)

  useEffect(() => {
    if (!hydrated || triggered.current) {
      return
    }
    const aborted = { value: false }

    ;(async () => {
      await waitForPageView('Tunnel de vente', aborted)
      if (aborted.value || triggered.current) {
        return
      }
      triggered.current = true;
      gtmPushCartEvent({ event, cart: fixItemsTitle(cart) })
    })()

    return () => {
      aborted.value = true
    }
  }, [hydrated, fixItemsTitle])

  return null
}

export default CartGtmEvent
